import { Component } from '@angular/core';
import { PageOptimizationBase } from '../base/base.component';

@Component({
  selector: 'app-components-specialist-actioncomponents-page-optimization-rewrite-content',
  templateUrl: './rewrite-content.component.html'
})
export class PageOptimizationRewriteContentComponent extends PageOptimizationBase {
  isStepReadyToReject(): boolean {
    return false;
  }
}
